import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { MdCheck } from 'react-icons/md'
import { useHistory } from 'react-router-dom'
import { Divider, Grid } from '@material-ui/core'

import { useCartao } from 'modules/pagamentos/hooks/useCartao'
import { Feedback } from 'shared/components/Feedback'
import Modal from 'shared/components/Modal'
import Scaffold from 'shared/components/Scaffold'
import Slider from 'shared/components/Slider'
import SnackBar from 'shared/components/SnackBar'
import { colors } from 'shared/styles/colors'
import { registerEvent } from 'shared/services/TrackingGAService'
import { useFrotista } from 'modules/user/hooks/useFrotista'

import PagamentosRoutes from '../../../utils/PagamentoRoutes'
import { IPorcentagemTransferenciaProps } from './PorcentagemTransferenciaComponent.types'
import { Label, FormSliderStyled, Title, SubTitle, StyledCheck } from './styles'
import Button from 'shared/components/Button'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import { useOnboarding } from 'modules/pagamentos/hooks/useOnboarding'

export const PorcentagemTrasferencias: React.FC<IPorcentagemTransferenciaProps> =
  ({
    updatePercentualTransferenciaMotorista,
    getPercentualTransferenciaMotorista,
    showScaffold = true,
  }) => {
    const history = useHistory()
    const { frotistaId } = useFrotista()
    const { setActiveMenu } = useCartao()
    const { setShowPercentualTransferencia, setSuccess } = useOnboarding()
    const [
      valorSliderAdiantamentoPCentTransferencia,
      setValorSliderAdiantamentoPCentTransferencia,
    ] = useState<number | number[]>(0)
    const [
      valorSliderSaldoPCentTransferencia,
      setValorSliderSaldoPCentTransferencia,
    ] = useState<number | number[]>(0)
    const [
      valorSliderEstadiaPCentTransferencia,
      setValorSliderEstadiaPCentTransferencia,
    ] = useState<number | number[]>(0)
    const [
      valorSliderOutrosValoresPCentTransferencia,
      setValorSliderOutrosValoresPCentTransferencia,
    ] = useState<number | number[]>(0)
    const [loading, setLoading] = useState(false)
    const [openErrorMessage, setOpenErrorMessage] = useState(false)
    const [errorMessage, setErrorMessage] = useState<string>('')
    const [openModal, setOpenModal] = useState(false)

    useEffect(() => {
      const init = async () => {
        setLoading(true)
        try {
          const response = await getPercentualTransferenciaMotorista.execute(
            frotistaId,
          )

          setValorSliderAdiantamentoPCentTransferencia(
            response.percentual_adiantamento,
          )
          setValorSliderSaldoPCentTransferencia(response.percentual_saldo)
          setValorSliderEstadiaPCentTransferencia(response.percentual_estadia)
          setValorSliderOutrosValoresPCentTransferencia(response.percentual_rpa)

          setLoading(false)
        } catch (e: unknown) {
          if (e instanceof Error) {
            setErrorMessage(e.message || 'Erro ao atualizar os valores')
          } else {
            setErrorMessage('Erro ao atualizar os valores')
          }
          setOpenErrorMessage(true)
          setLoading(false)
        }
      }

      init()
    }, [])

    const getValueSlider = (value: number | number[]) => {
      return typeof value === 'number' ? value : value[0]
    }

    const handleSubmit = useCallback(async () => {
      registerEvent({
        categoria: 'Pagamentos',
        acao: 'Alteração do percentual de transferência',
        local: 'Tela de percentual de transferência',
      })
      setLoading(true)

      try {
        await updatePercentualTransferenciaMotorista.execute({
          percentual_adiantamento: getValueSlider(
            valorSliderAdiantamentoPCentTransferencia,
          ),
          percentual_saldo: getValueSlider(valorSliderSaldoPCentTransferencia),
          percentual_estadia: getValueSlider(
            valorSliderEstadiaPCentTransferencia,
          ),
          percentual_rpa: getValueSlider(
            valorSliderOutrosValoresPCentTransferencia,
          ),
          percentual_abastecimento: getValueSlider(
            valorSliderOutrosValoresPCentTransferencia,
          ),
          percentual_tarifa_antt: getValueSlider(
            valorSliderOutrosValoresPCentTransferencia,
          ),
          percentual_abono: getValueSlider(
            valorSliderOutrosValoresPCentTransferencia,
          ),
          frotista_id: frotistaId,
        })

        setOpenModal(true)
        setLoading(false)
      } catch (e: unknown) {
        if (e instanceof Error) {
          setErrorMessage(e.message || 'Erro ao atualizar os valores')
        } else {
          setErrorMessage('Erro ao atualizar os valores')
        }
        setOpenErrorMessage(true)
        setLoading(false)
      }
    }, [
      updatePercentualTransferenciaMotorista,
      valorSliderAdiantamentoPCentTransferencia,
      valorSliderEstadiaPCentTransferencia,
      valorSliderOutrosValoresPCentTransferencia,
      valorSliderSaldoPCentTransferencia,
      frotistaId,
    ])

    const handleChangeSliderValueAdiantamentoPCentTransferencia = (
      event: ChangeEvent<HTMLInputElement>,
      newValue: number | number[],
    ) => {
      setValorSliderAdiantamentoPCentTransferencia(newValue)
    }

    const handleChangeSliderValueSaldoPCentTransferencia = (
      event: ChangeEvent<HTMLInputElement>,
      newValue: number | number[],
    ) => {
      setValorSliderSaldoPCentTransferencia(newValue)
    }

    const handleChangeSliderValueEstadiaPCentTransferencia = (
      event: ChangeEvent<HTMLInputElement>,
      newValue: number | number[],
    ) => {
      setValorSliderEstadiaPCentTransferencia(newValue)
    }

    const handleChangeSliderValueOutrosValoresPCentTransferencia = (
      event: ChangeEvent<HTMLInputElement>,
      newValue: number | number[],
    ) => {
      setValorSliderOutrosValoresPCentTransferencia(newValue)
    }

    const marks = [
      {
        value: 0,
        label: '0%',
      },
      {
        value: 100,
        label: '100%',
      },
    ]

    const handleClosePercentualTransferencia = () => {
      setShowPercentualTransferencia(false)
      setSuccess(true)
    }

    if (showScaffold)
      return (
        <>
          <Scaffold
            isNextButtonDisabled={false}
            onClickNextButton={handleSubmit}
            titleBackButton="Voltar"
            titleNextButton={'Salvar'}
            showFooterScaffold
            icon={MdCheck}
            color={colors.green}
            title="% de transferência"
            loading={loading}
          >
            <Grid container>
              <Grid item xs={4}>
                <FormSliderStyled>
                  <Label>Adiantamento para o motorista</Label>
                  <Slider
                    value={valorSliderAdiantamentoPCentTransferencia}
                    onChange={
                      handleChangeSliderValueAdiantamentoPCentTransferencia
                    }
                    marks={marks}
                    min={0}
                    max={100}
                    valueLabelFormat={`${valorSliderAdiantamentoPCentTransferencia}%`}
                  />
                </FormSliderStyled>
              </Grid>
              <Grid item xs={4}>
                <FormSliderStyled>
                  <Label>Saldo para o motorista</Label>
                  <Slider
                    value={valorSliderSaldoPCentTransferencia}
                    onChange={handleChangeSliderValueSaldoPCentTransferencia}
                    marks={marks}
                    min={0}
                    max={100}
                    valueLabelFormat={`${valorSliderSaldoPCentTransferencia}%`}
                  />
                </FormSliderStyled>
              </Grid>
              <Grid item xs={4}>
                <FormSliderStyled>
                  <Label>Estadia para o motorista</Label>
                  <Slider
                    value={valorSliderEstadiaPCentTransferencia}
                    onChange={handleChangeSliderValueEstadiaPCentTransferencia}
                    marks={marks}
                    min={0}
                    max={100}
                    valueLabelFormat={`${valorSliderEstadiaPCentTransferencia}%`}
                  />
                </FormSliderStyled>
              </Grid>
              <Grid item xs={4}>
                <FormSliderStyled>
                  <Label>Outros valores</Label>
                  <Slider
                    value={valorSliderOutrosValoresPCentTransferencia}
                    onChange={
                      handleChangeSliderValueOutrosValoresPCentTransferencia
                    }
                    marks={marks}
                    min={0}
                    max={100}
                    valueLabelFormat={`${valorSliderOutrosValoresPCentTransferencia}%`}
                  />
                </FormSliderStyled>
              </Grid>
            </Grid>
          </Scaffold>
          <SnackBar
            open={openErrorMessage}
            setOpen={setOpenErrorMessage}
            severity="error"
            message={errorMessage}
            horizontal="right"
          />
          <Modal size={'small'} openModal={openModal} showCloseButton={false}>
            <Feedback
              color={colors.blue}
              showLogo={false}
              title="Alteração feita com sucesso!"
              sizeIcon={100}
              onClickButton={() => {
                setActiveMenu('extrato')
                history.push(PagamentosRoutes.PAGAMENTO, {
                  reloadHomePagamento: false,
                })
              }}
              backgroundColor={colors.white}
            />
          </Modal>
        </>
      )

    return (
      <>
        {loading && <LoadingBackdrop open={loading} />}
        <Grid
          container
          style={{ padding: 32, background: colors.white, margin: 32 }}
        >
          <Title>Defina as porcentagens de transferências</Title>
          <Divider style={{ width: '100%' }} />

          <Grid container>
            <Grid item xs={4}>
              <FormSliderStyled>
                <Label>Adiantamento para o motorista</Label>
                <Slider
                  value={valorSliderAdiantamentoPCentTransferencia}
                  onChange={
                    handleChangeSliderValueAdiantamentoPCentTransferencia
                  }
                  marks={marks}
                  min={0}
                  max={100}
                  valueLabelFormat={`${valorSliderAdiantamentoPCentTransferencia}%`}
                />
              </FormSliderStyled>
            </Grid>
            <Grid item xs={4}>
              <FormSliderStyled>
                <Label>Saldo para o motorista</Label>
                <Slider
                  value={valorSliderSaldoPCentTransferencia}
                  onChange={handleChangeSliderValueSaldoPCentTransferencia}
                  marks={marks}
                  min={0}
                  max={100}
                  valueLabelFormat={`${valorSliderSaldoPCentTransferencia}%`}
                />
              </FormSliderStyled>
            </Grid>
            <Grid item xs={4}>
              <FormSliderStyled>
                <Label>Estadia para o motorista</Label>
                <Slider
                  value={valorSliderEstadiaPCentTransferencia}
                  onChange={handleChangeSliderValueEstadiaPCentTransferencia}
                  marks={marks}
                  min={0}
                  max={100}
                  valueLabelFormat={`${valorSliderEstadiaPCentTransferencia}%`}
                />
              </FormSliderStyled>
            </Grid>
            <Grid item xs={4}>
              <FormSliderStyled>
                <Label>Outros valores</Label>
                <Slider
                  value={valorSliderOutrosValoresPCentTransferencia}
                  onChange={
                    handleChangeSliderValueOutrosValoresPCentTransferencia
                  }
                  marks={marks}
                  min={0}
                  max={100}
                  valueLabelFormat={`${valorSliderOutrosValoresPCentTransferencia}%`}
                />
              </FormSliderStyled>
            </Grid>
          </Grid>
          <Divider style={{ width: '100%' }} />

          <Grid container justifyContent="flex-end">
            <Button
              style={{
                border: `1px solid ${colors.green}`,
                marginRight: 32,
              }}
              transparent
              fontColor={colors.green}
              onClick={handleClosePercentualTransferencia}
            >
              Voltar
            </Button>
            <Button color={colors.green} onClick={handleSubmit}>
              Salvar
            </Button>
          </Grid>
        </Grid>
        <SnackBar
          open={openErrorMessage}
          setOpen={setOpenErrorMessage}
          severity="error"
          message={errorMessage}
          horizontal="right"
        />
        <Modal
          openModal={openModal}
          curvature={true}
          showCloseButton={true}
          onCloseModal={handleClosePercentualTransferencia}
        >
          <Grid
            md={12}
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            style={{ textAlign: 'center', height: '100%' }}
          >
            <Grid container alignItems="center" justify="center" spacing={4}>
              <Grid item>
                <StyledCheck />
              </Grid>
            </Grid>
            <Title>As porcentagens de transferências foram definidas</Title>
            <Grid container item>
              <SubTitle>
                Caso necessário, você poderá alterá-las novamente quando sua
                conta for aprovada.
              </SubTitle>
            </Grid>
            <Grid container justifyContent="center" style={{ width: '100%' }}>
              <Button
                color={colors.green}
                onClick={handleClosePercentualTransferencia}
              >
                Fechar
              </Button>
            </Grid>
          </Grid>
        </Modal>
      </>
    )
  }

export default PorcentagemTrasferencias
